<div class="auth-in-progress-background"></div>
